import { render, staticRenderFns } from "./Tab1UserPassword.vue?vue&type=template&id=6d9aa999"
import script from "./Tab1UserPassword.vue?vue&type=script&lang=ts"
export * from "./Tab1UserPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports